import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { VariableSizeList } from "react-window";
import { findIndex } from "lodash";
import { makeStyles } from "@mui/styles";

import { selectedSectionSelector } from "../../reducers/ownApp/selectors";
import {
  sectionEditModeSelector,
  sectionEditSelector,
} from "../../reducers/sectionManagement/selectors";

import { SectionCardBase } from "./SectionCardBase";
import { View } from "../View";

const useStyles = makeStyles(({ typography }) => ({
  item: {
    marginTop: typography.pxToRem(2),
  },
  noScrollbar: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const SectionList = memo(({ sections, height = 900 }) => {
  const listRef = useRef();
  const selectedSection = useSelector(selectedSectionSelector);
  const sectionEdit = useSelector(sectionEditSelector);
  const sectionEditMode = useSelector(sectionEditModeSelector);
  const styles = useStyles();

  useEffect(() => {
    if ((!selectedSection && !sectionEdit) || !sections) return;
    const focusDriver = sectionEdit || selectedSection;
    listRef.current.resetAfterIndex(0, true);
    let selectedIndex = findIndex(
      sections,
      (section) => section.sectionCode === focusDriver.sectionCode
    );
    if (selectedIndex < 0) return;
    listRef.current.scrollToItem(selectedIndex, "start");
  }, [sections, selectedSection, sectionEdit]);

  useEffect(() => {
    listRef?.current.resetAfterIndex(0, true);
  }, [sections]);

  const renderRow = ({ index, style }) => {
    const section = sections[index];
    const inEdit = sectionEdit?.sectionCode === section.sectionCode;
    const selected = section.sectionCode === selectedSection?.sectionCode;
    return (
      <View
        className={styles.item}
        key={index}
        style={style}
        id={`section-card-${index}`}
      >
        <SectionCardBase
          height={style.height}
          section={section}
          editMode={sectionEditMode}
          inEdit={inEdit}
          selected={selected}
        />
      </View>
    );
  };

  const getItemSize = () => 190;

  return (
    <>
      {Array.isArray(sections) && (
        <VariableSizeList
          className={styles.noScrollbar}
          ref={listRef}
          height={height}
          itemCount={sections.length}
          itemSize={getItemSize}
          width={314}
        >
          {renderRow}
        </VariableSizeList>
      )}
    </>
  );
});

export default SectionList;
